<script lang="ts" setup>
defineProps<{
  title: string
  description?: string
  iconName: string
  isLoading?: boolean
}>()
</script>

<template>
  <div>
    <header class="space-y-0.5 bg-gray-50 p-3 md:px-6 border-b">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <Icon :name="iconName" size="24px" class="text-hos-blue" />
          <h1 class="text-lg font-bold">
            {{ title }}
          </h1>
        </div>
        <slot name="headerExtra" />
      </div>

      <p v-if="description">
        {{ description }}
      </p>
    </header>

    <div class="space-y-2 p-3 md:px-5">
      <n-skeleton v-if="isLoading" class="rounded" height="25vh" width="100%" :sharp="false" />
      <slot v-else />
    </div>
  </div>
</template>
